<template>
	<v-container>
		<v-row v-if='result.pickOne' justify='center' no-gutters>
			<v-col cols='12'>
				<span class='font-weight-bold text-uppercase text-h6'>PICK 1</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display :digit='result.pickOne' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.pickTwo' justify='center' no-gutters>
			<v-col cols='12'>
				<span class='font-weight-bold text-uppercase text-h6'>PICK 2</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display :digit='result.pickTwo' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.cashThree' justify='center' no-gutters>
			<v-col cols='12' class="d-flex justify-center">
				<v-img v-if='pickThreeImage' v-bind="pickThreeImage"></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display class='d-flex' :digit='result.cashThree' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.pickFour' justify='center' no-gutters>
			<v-col cols='12' class="d-flex justify-center">
				<v-img v-if='pickFourImage' v-bind="pickFourImage"></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display class='d-flex' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.first || result.second || result.third' justify='center' no-gutters>
			<slot name="first-second-third-header">
				<v-col cols='12'>
					<span class='font-weight-bold text-uppercase text-h6'>LOTTERY</span>
				</v-col>
			</slot>
			<v-col cols='auto' class='d-flex'>
				<digit-image-display display-as-one class='d-flex' :digit='result.first' :image-dimensions='imageDimensions' />
				<digit-image-display display-as-one class='d-flex' :digit='result.second' :image-dimensions='imageDimensions' />
				<digit-image-display display-as-one class='d-flex' :digit='result.third' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';
import ResultDisplay from '@homepage/components/ResultDisplay.js';

export default {
	name: 'ResultDisplay',
	extends: ResultDisplay,
	components: {
		DigitImageDisplay
	}
};
</script>

<style>
</style>
